import { styled } from "linaria/react";

export const OrganizationDescription = styled.div`
  grid-area: description;
  font-style: italic;
`;
